var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 25320"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#77777a",
  strokeWidth: 1.5,
  "data-name": "pin"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M4.93 15.536h14.142",
  "data-name": "Line 1899"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M7.758 5.636h8.485",
  "data-name": "Line 1900"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m7.257 15.536 2.825-9.9",
  "data-name": "Line 1901"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.746 15.538-2.828-9.9",
  "data-name": "Path 5261"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M12 15.536 12.108 21",
  "data-name": "Line 1903"
})))));
export { SvgPin as ReactComponent };
export default "/_next/static/images/Pin.svg";